/**
 * Freezes an object outside production, matching the flux stores, so that consumers such as diffItemArrays can
 * verify that items derived from store state are never mutated. Production skips the freeze for speed.
 *
 * This module must stay free of imports: the runtime overlays use it and must not pull in the overlay registry.
 */
export function freezeOutsideProduction<T extends object>(value: T): T {
  if (process.env.NODE_ENV !== 'production') {
    Object.freeze(value);
  }
  return value;
}
